import fieldtypes  from './fieldtypes.json'
import fieldtypesCustoms from './fieldtypes-Customs.json'

const allfieldstypes = {...fieldtypes, ...fieldtypesCustoms}


export default allfieldstypes
